// Icon for an operator type (GetOpTypes → name). The API sends no icon,
// so we pick one by keywords in the name. Order matters: more specific first.

const ICONS = {
  phone: (
    <>
      <rect x={7} y={2.5} width={10} height={19} rx={2.5} />
      <path d="M11 18h2" />
    </>
  ),
  tv: (
    <>
      <rect x={3} y={6} width={18} height={12} rx={2} />
      <path d="M8 21h8M9 2.5l3 3.5 3-3.5" />
    </>
  ),
  landline: (
    <path d="M5 4h4l2 5-2.5 1.5a11 11 0 005 5L15 13l5 2v4a2 2 0 01-2 2A16 16 0 013 6a2 2 0 012-2" />
  ),
  bolt: <path d="M13 3L5 13h6l-1 8 8-10h-6l1-8z" />,
  meter: (
    <>
      <rect x={4} y={3} width={16} height={18} rx={2} />
      <path d="M8 7h8v4H8zM12.5 14l-2 3h3l-2 3" />
    </>
  ),
  flame: (
    <path d="M12 3c3 4 6 6.5 6 10.5a6 6 0 01-12 0c0-2.5 1.5-4 3-5.5 0 2 1 3 2 3 0-3 0-5 1-8z" />
  ),
  wifi: (
    <>
      <path d="M2.5 9a14 14 0 0119 0M5.5 12.5a9.5 9.5 0 0113 0M8.8 16a5 5 0 016.4 0" />
      <circle cx={12} cy={19.5} r={0.9} />
    </>
  ),
  drop: <path d="M12 3s6 6.5 6 11a6 6 0 01-12 0c0-4.5 6-11 6-11z" />,
  bank: <path d="M3 10l9-6 9 6M5 10v8M9.5 10v8M14.5 10v8M19 10v8M3 20.5h18" />,
  shield: <path d="M12 3l8 4v5c0 5-3.4 8.5-8 9-4.6-.5-8-4-8-9V7l8-4z" />,
  tag: (
    <>
      <rect x={3} y={7} width={18} height={10} rx={2} />
      <path d="M7 12h4" />
    </>
  ),
  train: (
    <>
      <rect x={6} y={3} width={12} height={14} rx={3} />
      <path d="M6 11h12M9 21l1-4M15 21l-1-4" />
    </>
  ),
  card: (
    <>
      <rect x={3} y={5} width={18} height={14} rx={2} />
      <path d="M3 10h18M7 15h3" />
    </>
  ),
  building: <path d="M4 21V8l8-5 8 5v13M9 21v-6h6v6M3 21h18" />,
  receipt: <path d="M6 3h12v18l-3-2-3 2-3-2-3 2V3zM9 8h6M9 12h6" />,
  education: (
    <path d="M2 9l10-5 10 5-10 5-10-5zM6 11v5c0 1.5 3 3 6 3s6-1.5 6-3v-5" />
  ),
  home: <path d="M3 11l9-7 9 7M5 10v10h14V10M10 20v-5h4v5" />,
  hospital: (
    <>
      <rect x={3} y={3} width={18} height={18} rx={3} />
      <path d="M12 8v8M8 12h8" />
    </>
  ),
  play: (
    <>
      <rect x={3} y={3} width={18} height={18} rx={3} />
      <path d="M10 8.5v7l5.5-3.5L10 8.5z" />
    </>
  ),
  users: (
    <>
      <circle cx={9} cy={8} r={3} />
      <path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6M16 5a3 3 0 010 6M18 14c1.8.8 3 3 3 6" />
    </>
  ),
  scale: <path d="M12 4v16M7 20h10M5 7h14M5 7l-3 6h6L5 7zM19 7l-3 6h6l-3-6z" />,
  wallet: (
    <>
      <path d="M4 7a2 2 0 012-2h11v4M4 7v11a2 2 0 002 2h14V9H6a2 2 0 01-2-2z" />
      <circle cx={16} cy={14.5} r={1} />
    </>
  ),
  heart: (
    <path d="M12 20s-7-4.5-7-10a4 4 0 017-2.6A4 4 0 0119 10c0 5.5-7 10-7 10z" />
  ),
  idcard: (
    <>
      <rect x={3} y={5} width={18} height={14} rx={2} />
      <circle cx={9} cy={11} r={2} />
      <path d="M6.5 16c.5-1.5 1.5-2 2.5-2s2 .5 2.5 2M14 10h4M14 14h4" />
    </>
  ),
  user: (
    <>
      <circle cx={12} cy={8} r={4} />
      <path d="M4 21c0-4.4 3.6-8 8-8s8 3.6 8 8" />
    </>
  ),
  piggy: (
    <path d="M5 11a7 6 0 0114 0v3l2 1v3h-3l-1 3h-3v-2h-4v2H7l-1-3c-1.5-1-2-2.5-2-4M9 8h4M16 11h.01" />
  ),
  doc: (
    <>
      <rect x={4} y={3} width={16} height={18} rx={2} />
      <path d="M8 8h8M8 12h8M8 16h5" />
    </>
  ),
};

const RULES = [
  [/prepaid meter|meter/, "meter"],
  [/electric/, "bolt"],
  [/prepaid|postpaid|mobile/, "phone"],
  [/dth|cable|subscription|ott/, "tv"],
  [/landline/, "landline"],
  [/gas|lpg|cylinder/, "flame"],
  [/broadband|wifi|internet/, "wifi"],
  [/water/, "drop"],
  [/recurring|deposit/, "piggy"],
  [/insurance/, "shield"],
  [/pension/, "bank"],
  [/loan|\bemi\b/, "bank"],
  [/fastag/, "tag"],
  [/metro|rail/, "train"],
  [/pan ?card|\bpan\b/, "idcard"],
  [/credit card|ncmc|card/, "card"],
  [/challan/, "receipt"],
  [/municipal|tax/, "building"],
  [/bar association/, "scale"],
  [/education|school|fee/, "education"],
  [/housing|society|rent/, "home"],
  [/hospital|health/, "hospital"],
  [/google play|voucher/, "play"],
  [/club|association/, "users"],
  [/wallet/, "wallet"],
  [/donation/, "heart"],
  [/agent/, "user"],
];

const pickIcon = (name = "") => {
  const n = name.toLowerCase();
  const rule = RULES.find(([re]) => re.test(n));
  return ICONS[rule ? rule[1] : "doc"];
};

export default function CategoryIcon({ name, size = 18, stroke = "currentColor" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {pickIcon(name)}
    </svg>
  );
}
